import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b6623cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = { class: "sync-table" }

import { isString } from 'lodash'
import { t } from '@/plugins/i18n'
import { ref, reactive, computed, nextTick, toRaw, watch, onMounted } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import { setNoEmptyForm } from '@/util/common'
import { ElMessage } from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { delProduct, amazonPage } from '@/apis/order'
import { updateAmazonProductApi } from '@/apis/goods'
import { getPrepCategoryListApi, getCrossMallProductListApi, delCrossMallProductListApi } from '@/apis/stock'
import { crossmallSyncAllGoods, crossmallOneSyncAllGoods } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { isJA, useRtfix } from '@/store'
import BatchSearch from '@/components/BatchSearch/index.vue'
import AmazonTip from './AmazonTip.vue'
import bus from '@/util/useBus'
import { useRouter } from 'vue-router'
import { labelMap } from './data'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const tableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: t('操作') }
}
const updateLoading = ref(false)

const columns = computed(() => {
  return [
    {
      label: t('序号'),
      prop: 'index',
      slotName: 'index',
      width: 100
    },
    {
      label: '商品コード',
      prop: 'productCode',
      align: 'center'
    },
    {
      label: 'SKUコード',
      prop: 'productSku',
      align: 'center'
    },
    {
      label: '商品名',
      prop: 'productName',
      align: 'center'
    },
    {
      label: '属性１名',
      prop: 'prop1',
      align: 'center'
    },
    {
      label: '属性２名',
      prop: 'prop2',
      align: 'center'
    },
    {
      label: '商品規格',
      prop: 'productProp',
      align: 'center'
    }
    // {
    //   label: 'ステータス',
    //   prop: 'amazonFnsku',
    //   align: 'center'
    // }
  ]
})
const [syncLoading, syncApi] = useRequest(crossmallSyncAllGoods)
const setSyncProduct = async () => {
  // const unbind = await confirmApiUnbind()
  // if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('同步商品进行中，请等待1-3分钟'))
      setTimeout(() => refreshTable(true), 1000)
    }
  })
}

const delOrder = (row: any) => {
  row.delLoading = true
  delCrossMallProductListApi({ crossMallSku: row.productSku }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      refreshTable()
    }
  }).finally(() => { row.delLoading = false })
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const searchForm: any = ref({})

const store = useStore()
const customerShopId = store.getters.curShop
const isCrossMall = computed(() => store.getters.isCrossMall)
const filterData = computed(() => {
  const data = { ...toRaw(searchForm.value) }
  console.log('data', data)
  if (isString(data.crossMallSkuList) && data.crossMallSkuList) {
    data.crossMallSkuList = [data.crossMallSkuList]
  }
  return {
    customerShopId,
    ...setNoEmptyForm({
      ...data
    })
  }
})

const pageData = ref({
  page: 1,
  limit: 30
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    customerShopId
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
const updateGoods = async (row:{amazonMsku:string, updateLoading?:boolean}) => {
  if (updateLoading.value || row.updateLoading) return
  updateLoading.value = true
  row.updateLoading = true
  const { success } = await crossmallOneSyncAllGoods({
    productCodeList: [row.productCode]
  })
  if (success) {
    ElMessage.success(t('更新成功'))
    refreshTable()
  }
  row.updateLoading = false
  await new Promise((resolve) => setTimeout(resolve, 3000))
  updateLoading.value = false
}

onMounted(() => {
  if (!isCrossMall.value) {
    router.replace(useRtfix('SyncProduct'))
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SSearch, {
      form: searchForm.value,
      "onUpdate:form": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchForm).value = $event)),
        search
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"margin-left":"6px"},
            type: "primary",
            loading: _unref(syncLoading),
            onClick: setSyncProduct
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('同步商品')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((pageData).value = $event)),
        api: _unref(getCrossMallProductListApi),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: _unref(columns),
        "table-config": tableConfig
      }, {
        handler: _withCtx(({ scope }) => [
          _createVNode(_component_el_popconfirm, {
            "popper-class": "pay-pop",
            title: _unref(t)('是否删除'),
            onConfirm: ($event: any) => (delOrder(scope.row))
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('删除'),
                loading: scope.row.delLoading
              }, null, 8, ["title", "loading"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"]),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(_component_table_button, {
                key: 0,
                title: _unref(t)('更新'),
                loading: scope.row.updateLoading,
                onClick: ($event: any) => (updateGoods(scope.row))
              }, null, 8, ["title", "loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        index: _withCtx(({rowIndex}) => [
          _createElementVNode("div", null, _toDisplayString(rowIndex + 1), 1)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns"])
    ]),
    _createVNode(BatchSearch)
  ]))
}
}

})